import * as d3 from "d3";
import $ from "jquery";
import {
  ControllerGlobals,
  genericXHRErrorHandler,
  getAuthHeader,
  toastError,
  toastErrorSingle,
  toastInfo,
  toastRemoveAll
} from "src/components/Planner/controller";
import { createToolTooltip, drawToolBackground, getToolSize } from "src/components/Planner/planner/deviceTools";
import { CreateWallModAction, DeleteWallModAction } from "src/components/Planner/planner/history/wallmod-actions";
import { getMeasurementsOfWallModConn, redrawMeasurements, removeWallModFromMeasuresLocal } from "src/components/Planner/planner/measurement";
import { willCalcOuter } from "src/components/Planner/planner/outerwall";
import {
  changedWallIds,
  correctPos,
  getXY,
  getXYP,
  hideRotateAndDeviceTools,
  hideTools,
  isPlannerImperial,
  isPlannerMetric,
  pxToCM,
  setMode,
  toggleEditableWallViewMode,
  WALLSELECT_COLOR
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import { getRoomById, uDev } from "src/components/Planner/planner/uDev";
import {
  arrayIntersection,
  CMToPx,
  getWallById,
  lineClosestPointToPoint,
  P_numtoxy,
  segmentClosestPointToPoint_S,
  uMath
} from "src/components/Planner/planner/uMath";
import {
  activeClassName,
  getNeighborWallMod,
  MEASURE_LINE_MIN_PXLEN,
  wallModHelper
} from "src/components/Planner/planner/wallModHelper";
import { ROOT_URI } from "src/utils/constants";
import { hasPermissionForFuncInRole } from "src/utils/controllerHasPermissionsAdapter";
import { cmToInch } from "src/utils/imperialConverter";
import { ts } from "src/utils/translate";
import {getFrontendURL} from "src/utils/url";

/**
 * @typedef {Object} StraightPath
 * @property {number} roomId
 * @property {Point[]} points
 * @property {Segment} path
 * @property {number} angle
 * @property {number} wallId
 */

/**
 * @typedef {Object} StraightPath
 * @property {number} roomId
 * @property {Point[]} points
 * @property {Segment} path
 * @property {number} angle
 * @property {number} wallId
 */

/**
 * @typedef {Object} WallModIntersection
 * @property {number} roomId
 * @property {number} wallId
 * @property {WallModIntersectionMember[]} wallIntersects
 */

/**
 * @typedef {Object} WallModIntersectionMember
 * @property {number} roomId
 * @property {number} wallId
 * @property {Point} intersect
 */


let FAKE_WALLCONN_ID = 1;
let FAKE_WALLMOD_ID = 1;
const WALLSELECT_RECT_HEIGHT = 15.5;
const RULER_PATTERN_PATH = 'M11.6663 0.46V4.38996C11.6663 4.66996 11.5157 4.88996 11.3241 4.88996C11.1326 4.88996 10.982 4.66996 10.982 4.38996V0.959961H8.77192V8.40996C8.77192 8.67996 8.62139 8.90996 8.42981 8.90996C8.23822 8.90996 8.08769 8.67996 8.08769 8.40996V0.959961H6.29499V4.38996C6.29499 4.66996 6.13761 4.88996 5.95287 4.88996C5.76812 4.88996 5.61075 4.66996 5.61075 4.38996V0.959961H3.59909V8.40996C3.59909 8.67996 3.44856 8.90996 3.25697 8.90996C3.06538 8.90996 2.91485 8.67996 2.91485 8.40996V0.959961H0.684238V4.38996C0.684238 4.66996 0.526863 4.88996 0.342119 4.88996C0.157375 4.88996 0 4.66996 0 4.38996V0H11.6663V0.46ZM11.6799 16.44H0.0205263V16.94H11.6799V16.44Z';
const RULER_PATTERN_BASE_WIDTH = 11;

let dragLineBaseTransform = '';
let dragLineAccumX = 0;
let dragLineAccumY = 0;

const dragLine = d3.drag()
  .subject(function(event, d) { return d; })
  .on('start', dragLineStarted)
  .on('drag', dragLineOnDragged)
  .on('end', dragLineEnded);

export function dragLineStarted() {
  PlannerGlobals.draggingRoomCircle = true;
  PlannerGlobals.draggingSomething = true;
  d3.select('.wallSelectModifyCircles').style('visibility', 'hidden');
  d3.select(this).classed(activeClassName, true);
  dragLineBaseTransform = d3.select(this).attr('transform') || '';
  dragLineAccumX = 0;
  dragLineAccumY = 0;
}

export function entitySelectUpdate() {
  if (PlannerGlobals.mode != 'entitySelect') {
    return;
  }
  var THRESHOLD = 18;
  var currPt = getXYP();
  d3.selectAll('.entitySelectPt').remove();
  PlannerGlobals.entitySelectClosestPt = null;
  // just starting out
  if (!PlannerGlobals.entitySelectStartPos) {
    PlannerGlobals.entitySelectClosestPts = uDev.closestWallPtToPoint(currPt, THRESHOLD);
    PlannerGlobals.entitySelectClosestPt = PlannerGlobals.entitySelectClosestPts[0];
    if (PlannerGlobals.entitySelectClosestPt) {
      PlannerGlobals.container.append('circle')
        .attr('cx', PlannerGlobals.entitySelectClosestPt.x)
        .attr('cy', PlannerGlobals.entitySelectClosestPt.y)
        .attr('r', 1.5)
        .attr('fill', 'white')
        .attr('fill-opacity', 0.5)
        .attr('stroke', 'black')
        .attr('stroke-width', 0.2)
        .attr('class', 'entitySelectPt');
    }
  }

  // drawing second pt
  else {
    var potentialWalls = PlannerGlobals.entitySelectClosestPts.map(function (entitySelectClosestPt) {
      var wall = getWallById(entitySelectClosestPt.wallId);
      var closestPt = segmentClosestPointToPoint_S(currPt, wall);
      var dist = uMath.pointDistance(currPt, closestPt);
      return { wall, dist, entitySelectClosestPt };
    });

    potentialWalls.sort(function (a, b) {
      return a.dist < b.dist ? -1 : 1;
    });

    PlannerGlobals.entitySelectStartPos = potentialWalls[0].entitySelectClosestPt;

    PlannerGlobals.container.append('circle')
      .attr('cx', PlannerGlobals.entitySelectStartPos.x)
      .attr('cy', PlannerGlobals.entitySelectStartPos.y)
      .attr('r', 1.5)
      .attr('fill', 'white')
      .attr('fill-opacity', 0.5)
      .attr('stroke', 'black')
      .attr('stroke-width', 0.2)
      .attr('class', 'entitySelectPt');
    var straightPaths = wallModHelper.roomStraightPaths(PlannerGlobals.entitySelectStartRoom);
    var seg = straightPaths.find(function (wallIds) {
      return wallIds.indexOf(PlannerGlobals.entitySelectStartPos.wallId) != -1;
    });
    /* var straightPathsOfWall = wallModHelper.roomStraightPathOfWall(entitySelectStartRoom.id, potentialWalls[0].wall.id); */
    /* var seg = wallModHelper.roomStraightPathOfWall(entitySelectStartRoom.id, potentialWalls[0].wall.id); */
    /* console.log(seg, straightPathsOfWall); */
    if (seg && seg.length) {
      var walls = seg.map(function (wallId) {
        var wall = getWallById(wallId);
        var closestPt = segmentClosestPointToPoint_S(currPt, wall);
        var dist = uMath.pointDistance(currPt, closestPt);
        return { x: closestPt.x, y: closestPt.y, wall, wallId: wall.id, roomId: wall.roomId, dist };
      })
      .filter(function (wall) {
        return wall.dist < THRESHOLD;
      });

      if (walls.length) {

        walls.sort(function (a, b) {
          return a.dist < b.dist ? -1 : 1;
        });

        PlannerGlobals.entitySelectClosestPt = walls[0];

        PlannerGlobals.container.append('circle')
          .attr('cx', PlannerGlobals.entitySelectClosestPt.x)
          .attr('cy', PlannerGlobals.entitySelectClosestPt.y)
          .attr('r', 1.5)
          .attr('fill', 'white')
          .attr('fill-opacity', 0.5)
          .attr('stroke', 'black')
          .attr('stroke-width', 0.2)
          .attr('class', 'entitySelectPt');
        var wallModLen = pxToCM(uMath.pointDistance(PlannerGlobals.entitySelectStartPos, PlannerGlobals.entitySelectClosestPt));
        var minLen = wallModHelper.minLengthCM[PlannerGlobals.entitySelectType];
        if (isPlannerImperial()) {
          wallModLen = cmToInch(wallModLen);
          minLen = wallModHelper.minLengthIN[PlannerGlobals.entitySelectType];
        }
        var strokeColor = wallModLen < minLen ? 'red' :
            (PlannerGlobals.entitySelectType == 'door' ? 'black' : '#3598dc');

        var selWallIds = wallModHelper.selectionRealWallIds(PlannerGlobals.entitySelectStartRoom.id, PlannerGlobals.entitySelectStartPos.wallId, PlannerGlobals.entitySelectClosestPt.wallId);
        var linePts = wallModHelper.polyLineFromSelection(PlannerGlobals.entitySelectStartPos, PlannerGlobals.entitySelectClosestPt, selWallIds);

        var lineFunction = d3.line()
          .x(function (d) { return d.x; })
          .y(function (d) { return d.y; })
          .curve(d3.curveLinear);

        PlannerGlobals.container.append('path')
          .attr('d', lineFunction(linePts))
          .attr('stroke', strokeColor)
          .attr('stroke-width', 1.5)
          .attr('fill', 'none')
          .attr('class', 'entitySelectPt');


        if (uMath.pointDistance(PlannerGlobals.entitySelectStartPos, PlannerGlobals.entitySelectClosestPt) > 0.1) {
          drawNeighborWallMod(PlannerGlobals.entitySelectStartPos, PlannerGlobals.entitySelectClosestPt, PlannerGlobals.entitySelectStartRoom.id);
        }
        /* console.log('draw2', walls[0]); */
      }
    }
  }

}

export function wallSelectStart(e) {
  if (PlannerGlobals.mode != 'wallSelect') return;
  if (e.which == 1) {
    if (!PlannerGlobals.wallSelectStartPos) {
      PlannerGlobals.wallSelectStartPos = getXY();
    } else {
      if (uMath.pointDistance(P_numtoxy(PlannerGlobals.wallSelectStartPos), P_numtoxy(PlannerGlobals.wallSelectEndPos)) > MEASURE_LINE_MIN_PXLEN) {
        PlannerGlobals.lastRatioPoints = {
          x1: PlannerGlobals.wallSelectStartPos[0],
          y1: PlannerGlobals.wallSelectStartPos[1],
          x2: PlannerGlobals.wallSelectEndPos[0],
          y2: PlannerGlobals.wallSelectEndPos[1]
        };
        setMode.wallSelectModify();
      }
      else {
        toastErrorSingle(ts('p_scale_short_err', "Please select a longer section."));
      }
    }
  } else if (e.which == 3) {
    if (PlannerGlobals.wallSelectStartPos) {
      PlannerGlobals.wallSelectStartPos = null;
      PlannerGlobals.wallSelectEndPos = null;
      d3.selectAll('.wallSelectLine').remove();
    } else {
      setMode.basic();
    }
  }
}

export function redrawWallSelectCircles()
{

  $(".wallSelectModifyCircles").remove();
  PlannerGlobals.wallSelectModData = [
    {
      type: 'start',
      t: [0, 0],
      pos: [PlannerGlobals.wallSelectStartPos[0], PlannerGlobals.wallSelectStartPos[1]]
    },
    {
      type: 'end',
      t: [0, 0],
      pos: [PlannerGlobals.wallSelectEndPos[0], PlannerGlobals.wallSelectEndPos[1]]
    },
  ]

  // if (newTour.isOngoing() && newTour.currStepId === 'set_scale') { return; }

  PlannerGlobals.container.append('g').attr('class', 'wallSelectModifyCircles')
  .selectAll('circle').data(PlannerGlobals.wallSelectModData).enter()
  .append('circle')
  .attr('class', 'wallSelectModifyCircle')
  .attr('cx', function (d) { return +d.pos[0]; })
  .attr('cy', function (d) { return +d.pos[1]; })
  .attr('r', 3)
  .attr('fill', '#fff')
  .attr('stroke', '#000')
  .attr('stroke-width', 0.2)
  .style('cursor', 'ew-resize')
  .call(PlannerGlobals.dragWallSelectLine);
}

export function wallSelectUpdate() {
  if (PlannerGlobals.mode !== 'wallSelect' || PlannerGlobals.wallSelectStartPos == null) return;

  PlannerGlobals.wallSelectEndPos = getXY();

  redrawWallSelectLine();
}

export function dragLineOnDragged(event, d) {

  d.x1 += event.dx;
  d.y1 += event.dy;
  d.x2 += event.dx;
  d.y2 += event.dy;

  PlannerGlobals.wallSelectStartPos = [d.x1, d.y1];
  PlannerGlobals.wallSelectEndPos = [d.x2, d.y2];

  correctPos(PlannerGlobals.wallSelectStartPos, PlannerGlobals.wallSelectEndPos);

  // Move the existing ruler instead of removing/recreating it (which made it
  // vanish mid-drag); the clean redraw happens on dragend.
  dragLineAccumX += event.dx;
  dragLineAccumY += event.dy;
  d3.select(this).attr('transform', 'translate(' + dragLineAccumX + ',' + dragLineAccumY + ') ' + dragLineBaseTransform);

  redrawWallSelectInput();

}

export function dragLineEnded() {
  d3.select(this).classed(activeClassName, false);
  PlannerGlobals.draggingRoomCircle = false;
  PlannerGlobals.draggingSomething = false;
  redrawWallSelectLine();
  redrawWallSelectCircles();
  d3.select('.wallSelectModifyCircles').style('visibility', 'visible');
}

export function redrawWallSelectLine() {

  const data = [
    {
      'x1': PlannerGlobals.wallSelectStartPos[0],
      'y1': PlannerGlobals.wallSelectStartPos[1],
      'x2': PlannerGlobals.wallSelectEndPos[0],
      'y2': PlannerGlobals.wallSelectEndPos[1]
    },
  ];

  d3.selectAll('.wallSelectLine').remove();

  const x1 = PlannerGlobals.wallSelectStartPos[0];
  const y1 = PlannerGlobals.wallSelectStartPos[1];
  const x2 = PlannerGlobals.wallSelectEndPos[0];
  const y2 = PlannerGlobals.wallSelectEndPos[1];

  const lineLen = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  const centerX = (x1 + x2) / 2;
  const centerY = (y1 + y2) / 2;
  const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
  const rectHeight = WALLSELECT_RECT_HEIGHT;

  const numUnits = Math.max(1, Math.round(lineLen / RULER_PATTERN_BASE_WIDTH));
  const unitWidth = lineLen / numUnits;
  const scaleX = unitWidth / RULER_PATTERN_BASE_WIDTH;

  const rectX = centerX - lineLen / 2;
  const rectY = centerY - rectHeight / 2;

  const rulerGroup = PlannerGlobals.container.append('g')
  .data(data)
  .attr('class', 'wallSelectLine')
  .attr('transform', 'rotate(' + angle + ' ' + centerX + ' ' + centerY + ')')
  .attr('style', 'cursor: move')
  .call(dragLine);

  const clipId = 'rulerClip-' + Date.now();
  rulerGroup.append('clipPath')
  .attr('id', clipId)
  .append('rect')
  .attr('x', rectX)
  .attr('y', rectY)
  .attr('width', lineLen)
  .attr('height', rectHeight);

  rulerGroup.append('rect')
  .attr('x', rectX)
  .attr('y', rectY)
  .attr('width', lineLen)
  .attr('height', rectHeight)
  .attr('fill', WALLSELECT_COLOR)
  .attr('stroke', '#000')
  .attr('stroke-width', 0.5);

  const patternGroup = rulerGroup.append('g')
  .attr('clip-path', 'url(#' + clipId + ')');

  for (let i = 0; i < numUnits; i++) {
    patternGroup.append('path')
    .attr('d', RULER_PATTERN_PATH)
    .attr('fill', 'black')
    .attr('transform', 'translate(' + (rectX + i * unitWidth) + ',' + (rectY - 1) + ') scale(' + scaleX + ', 1)');
  }

  redrawWallSelectInput();

  // Keep the drag handles above the ruler in z-order.
  const circlesGroup = d3.select('.wallSelectModifyCircles');
  if (!circlesGroup.empty()) {
    circlesGroup.each(function () {
      this.parentNode.appendChild(this);
    });
  }
}

export function redrawWallSelectInput() {
  var cont = d3.select('#svgAndChat').node();
  var line = d3.select('.wallSelectLine').node();
  if (cont && line) {
    const box = line.getBoundingClientRect();
    const contBox = cont.getBoundingClientRect();
    let left = box.left + (box.width - 260) / 2;
    let top = box.bottom + 5;

    if (left < contBox.left) {
      left = contBox.left;
    }
    if (top < (contBox.top + 50)) {
      top = contBox.top + 50;
    }
    if (left > (contBox.right - 260)) {
      left = contBox.right - 260;
    }
    if (top > (contBox.bottom - 130)) {
      top = contBox.bottom - 130;
    }

    PlannerGlobals.wallInput.attr('style', 'left: ' + left + 'px; top: ' + top + 'px;');
  }
}

export function moveWallSelectLine()
{

  const svg = document.querySelector('#plannerSVG');

  const line = document.querySelector('.wallSelectLine');

  let initialX, initialY;

  let isDraggingLine = false;

  line.addEventListener('mousedown', (e) => {

    isDraggingLine = true;
    initialX = e.clientX - line.getAttribute('x1');
    initialY = e.clientY - line.getAttribute('y1');
    PlannerGlobals.draggingRoomCircle = true;
    PlannerGlobals.draggingSomething = true;
    d3.select('.wallSelectModifyCircles').style('visibility', 'hidden');
  });

  svg.addEventListener('mousemove', (e) => {

    if (isDraggingLine) {
      const newX1 = e.clientX - initialX;
      const newY1 = e.clientY - initialY;
      const newX2 = newX1 + parseFloat(line.getAttribute('x2')) - parseFloat(line.getAttribute('x1'));
      const newY2 = newY1 + parseFloat(line.getAttribute('y2')) - parseFloat(line.getAttribute('y1'));

      PlannerGlobals.wallSelectStartPos[0] = newX1;
      PlannerGlobals.wallSelectStartPos[1] = newY1;
      PlannerGlobals.wallSelectEndPos[0] = newX2;
      PlannerGlobals.wallSelectEndPos[1] = newY2;
      redrawWallSelectLine();
      redrawWallSelectInput();
    }
  });

  svg.addEventListener('mouseup', (e) => {
    PlannerGlobals.draggingRoomCircle = false;
    PlannerGlobals.draggingSomething = false;
    redrawWallSelectCircles();
    d3.select('.wallSelectModifyCircles').style('visibility', 'visible');
    isDraggingLine = false;
  });
}

export function entitySelectClick() {
  if (PlannerGlobals.mode != 'entitySelect') return;
  if (!PlannerGlobals.entitySelectStartPos) {
    if (PlannerGlobals.entitySelectClosestPt) {
      PlannerGlobals.entitySelectStartPos = PlannerGlobals.entitySelectClosestPt;
      PlannerGlobals.entitySelectStartRoom = getRoomById(PlannerGlobals.entitySelectStartPos.roomId);
    }
  }
  else {
    if (PlannerGlobals.entitySelectClosestPt && uMath.pointDistance(PlannerGlobals.entitySelectClosestPt, PlannerGlobals.entitySelectStartPos) > 0.01) {
      PlannerGlobals.entitySelectEndPos = PlannerGlobals.entitySelectClosestPt;

      // TODO: add window/door

      var intersections = [
        {
          wallId: PlannerGlobals.entitySelectStartPos.wallId,
          roomId: PlannerGlobals.entitySelectStartPos.roomId,
          wallIntersects: [
            {
              intersect: {
                x: PlannerGlobals.entitySelectStartPos.x,
                y: PlannerGlobals.entitySelectStartPos.y
              },
              wallId: PlannerGlobals.entitySelectStartPos.wallId,
              roomId: PlannerGlobals.entitySelectStartPos.roomId,
            },
            {
              intersect: {
                x: PlannerGlobals.entitySelectEndPos.x,
                y: PlannerGlobals.entitySelectEndPos.y
              },
              wallId: PlannerGlobals.entitySelectEndPos.wallId,
              roomId: PlannerGlobals.entitySelectEndPos.roomId,
            },
          ]
        }
      ];
      var neighborWallMod = drawNeighborWallMod(PlannerGlobals.entitySelectStartPos, PlannerGlobals.entitySelectEndPos, PlannerGlobals.entitySelectStartRoom.id);

      if (neighborWallMod) {
        intersections.push({
          wallId: neighborWallMod.wallId,
          roomId: neighborWallMod.roomId,
          wallIntersects: [
            {
              intersect: {
                x: neighborWallMod.tarStart.x,
                y: neighborWallMod.tarStart.y
              },
              wallId: neighborWallMod.beginWallId,
              roomId: neighborWallMod.roomId,
            },
            {
              intersect: {
                x: neighborWallMod.tarEnd.x,
                y: neighborWallMod.tarEnd.y
              },
              wallId: neighborWallMod.endWallId,
              roomId: neighborWallMod.roomId,
            },
          ]
        });
      }

      wallModHelperDOM.processAndSendWallMods(intersections);

      d3.selectAll('.entitySelectPt').remove();
      PlannerGlobals.entitySelectStartPos = null;
      PlannerGlobals.entitySelectEndPos = null;
      entitySelectUpdate();
      return true;
    }
  }
}

export function drawNeighborWallMod(startPt, endPt, fromRoomId) {
  var neighbor = getNeighborWallMod(startPt, endPt, fromRoomId);
  if (neighbor) {
    var wallModLen = pxToCM(uMath.pointDistance(neighbor.tarStart, neighbor.tarEnd));
    var minLen = wallModHelper.minLengthCM[PlannerGlobals.entitySelectType];
    if (isPlannerImperial()) {
      wallModLen = cmToInch(wallModLen);
      minLen = wallModHelper.minLengthIN[PlannerGlobals.entitySelectType];
    }
    var strokeColor = wallModLen < minLen ? 'red' :
        (PlannerGlobals.entitySelectType == 'door' ? 'black' : '#3598dc');

    var selWallIds = wallModHelper.selectionRealWallIds(neighbor.roomId, neighbor.beginWallId, neighbor.endWallId);
    if (selWallIds.length == 0) {
      return [];
    }
    var linePts = wallModHelper.polyLineFromSelection(neighbor.tarStart, neighbor.tarEnd, selWallIds);

    var lineFunction = d3.line()
      .x(function (d) { return d.x; })
      .y(function (d) { return d.y; })
      .curve(d3.curveLinear);

    [neighbor.tarStart, neighbor.tarEnd].forEach(function (pt) {
      PlannerGlobals.container.append('circle')
        .attr('cx', pt.x)
        .attr('cy', pt.y)
        .attr('r', 1.5)
        .attr('fill', 'white')
        .attr('fill-opacity', 0.5)
        .attr('stroke', 'black')
        .attr('stroke-width', 0.2)
        .attr('class', 'entitySelectPt');
    });

    PlannerGlobals.container.append('path')
      .attr('d', lineFunction(linePts))
      .attr('stroke', strokeColor)
      .attr('stroke-width', 1.5)
      .attr('fill', 'none')
      .attr('class', 'entitySelectPt');

  }
  return neighbor;
}

export function deleteRoomWallModConns(roomId) {
  var wallModIdsToDel = [];
  PlannerGlobals.wallModConnections = PlannerGlobals.wallModConnections.filter(function (wallMod) {
    var shouldKeep = false;
    if (wallMod.rooms.length == 0) {
      shouldKeep = true;
    }
    else if (wallMod.rooms.length == 1) {
      shouldKeep = wallMod.rooms[0].roomId != roomId;
    }
    else if (wallMod.rooms.length == 2) {
      shouldKeep = !(wallMod.rooms[0].roomId == roomId || wallMod.rooms[1].roomId == roomId);
      if (!shouldKeep) {
        wallModIdsToDel.push(wallMod.id);
      }
    }
    if (!shouldKeep) {
      var segments = wallModHelper.getWallModsByConnId(wallMod.id);
      segments.forEach(function (segment) {
        removeWallModFromMeasuresLocal(segment.id);
      });
    }
    return shouldKeep;
  });
  wallModIdsToDel.forEach(function (id) {
    wallModHelperDOM.removeWallModConn(id);
  });
  wallModHelperDOM.redrawWallMods();
}

/**
 * @returns {WallModConn[]}
 */
export function deleteModdedWallModConns() {
  var moddedIds = changedWallIds();
  var removedConns = [];
  PlannerGlobals.wallModConnections.forEach(function (entity) {
    for (var room of entity.rooms) {
      if (arrayIntersection(moddedIds, room.wallIds).length > 0) {
        wallModHelperDOM.removeWallModConn(entity.id);
        removedConns.push(entity);
      }
    }
  });
  return removedConns;
}

export const wallModHelperDOM = {
  removeWallModConn: function (wallModConnId, callback, errorCallback) {
      return new Promise((res, rej) => {
        if (wallModHelper.getIsWallModConnAJAXWait(wallModConnId)) {
          if (typeof errorCallback === "function") {
            errorCallback();
          }
          return rej();
        }
  
        wallModHelper.setIsWallModConnAJAXWait(wallModConnId, true);
        wallModHelperDOM.redrawWallMods();
        redrawMeasurements();
        getAuthHeader(function (header) {
          $.ajax({
            headers: header,
            method: 'delete',
            url: ROOT_URI + '/segment/delete-segment',
            data: {
              segment_group_id: wallModConnId
            },
            success: function (resp) {
              wallModHelper.setIsWallModConnAJAXWait(wallModConnId, false);
              PlannerGlobals.wallModConnections = PlannerGlobals.wallModConnections.filter(function (elem) {
                if (elem.id != wallModConnId) {
                  return true;
                }
                else {
                  elem.rooms.forEach(function (room) {
                    removeWallModFromMeasuresLocal(room.id);
                  });
                  return false;
                }
              });
              hideTools();
              wallModHelperDOM.redrawWallMods();
              redrawMeasurements();
              willCalcOuter();
              if (typeof callback === "function") {
                callback();
              }
              return res();
            },
            error: function (resp) {
              wallModHelper.setIsWallModConnAJAXWait(wallModConnId, false);
              wallModHelperDOM.redrawWallMods();
              genericXHRErrorHandler(resp);
              if (typeof errorCallback === "function") {
                errorCallback();
              }
              return rej();
            }
          });
        });
      });
    },
  showWallTool: function (elem) {
      hideRotateAndDeviceTools();
      const sizes = getToolSize();
      const toolSize = sizes.size;
      const toolPadding = sizes.padding;
      var d3Elem = d3.select(elem);
      var elem = d3Elem.node();
      var center = elem.getPointAtLength(elem.getTotalLength() / 2);
  
      center.y -= toolSize / 2 + toolPadding + 1;
  
      var attrs = {
        wallId: +d3Elem.attr('data-wallModConnId')
      };
  
      const rectBox = {
        x: center.x - toolSize / 2 - toolPadding,
        y: center.y - toolSize / 2 - toolPadding,
        width: toolSize + toolPadding * 2,
        height: toolSize + toolPadding * 2,
      };
      drawToolBackground(PlannerGlobals.container, rectBox, { class: 'wall-tool' });
  
      PlannerGlobals.container
      .append('svg:image')
      .attr('width', toolSize)
      .attr('height', toolSize)
      .attr("x", center.x - toolSize / 2)
      .attr("y", center.y - toolSize / 2)
      .attr("xlink:href", `${getFrontendURL()}/images/planner_tools/delete.svg`)
      .attr('class', 'wall-tool wall-del-tool')
      .attr('title', ts("p_tool_delete", "Delete"));
  
      createToolTooltip('.wall-tool');
  
      $('.wall-del-tool').click(function () {
        var conn = wallModHelper.getWallModConnById(attrs.wallId);
        if (conn) {
          const wssd = PlannerGlobals.wallSegmentation.getSaveData();
          var measures = getMeasurementsOfWallModConn(attrs.wallId);
          wallModHelperDOM.removeWallModConn(attrs.wallId, function () {
            var action = new DeleteWallModAction(conn, measures, wssd);
            PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
            PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
  
            if (PlannerGlobals.plannerEditableWallViewEnable === true) {
              toggleEditableWallViewMode(true);
            }
          });
        }
      });
  
      $('.wall-tool').off('mousedown.tool');
      $('.wall-tool').on('mousedown.tool', function (e) {
        e.stopImmediatePropagation();
      });
  
      $('.wall-tool').off('mouseout.tool');
      $('.wall-tool').on('mouseout.tool', function () {
        if (PlannerGlobals.wallToolTimeout) {
          clearTimeout(PlannerGlobals.wallToolTimeout);
        }
        PlannerGlobals.wallToolTimeout = setTimeout(function () {
          hideTools();
        }, 2500);
      });
  
      $('.wall-tool').off('mouseenter.tool');
      $('.wall-tool').on('mouseenter.tool', function () {
        if (PlannerGlobals.wallToolTimeout) {
          clearTimeout(PlannerGlobals.wallToolTimeout);
        }
      });
    },
  redrawWallMods: function () {
      d3.select('.doorOrWindowContainer').remove();
      PlannerGlobals.container.insert('g', '.devices')
      .attr('class', 'doorOrWindowContainer');
      PlannerGlobals.wallModConnections.forEach(elem => {
        for (var i = 0; i < elem.rooms.length; i++) {
          if (getRoomById(elem.rooms[i].roomId)) {
            wallModHelper.drawLine(elem.rooms[i], elem);
          }
        }
      })
      $('.doorOrWindow').on('mouseenter', function () {
        if (PlannerGlobals.mode == 'basic' && !PlannerGlobals.isDragging && !ControllerGlobals.currentlyDraggedDevice &&
            hasPermissionForFuncInRole("planner_sect.show_prod_buttons", PlannerGlobals.userRoleInProject)) {
          var elem = this;
          wallModHelperDOM.showWallTool(elem);
        }
      })
    },
  neighborCorrection(intersections) {
      var points0 = wallModHelper.pointsFromIntersection(intersections[0]);
      var points1 = wallModHelper.pointsFromIntersection(intersections[1]);
  
      var wallIds0 = wallModHelper.wallIdsFromIntersection(intersections[0]);
      var wallIds1 = wallModHelper.wallIdsFromIntersection(intersections[1]);
  
      var isClockwise0 = uMath.isRoomClockwise(getRoomById(intersections[0].roomId));
      var isClockwise1 = uMath.isRoomClockwise(getRoomById(intersections[1].roomId));
  
      var pair1, pair2;
  
      if (uMath.pointDistance(points0[0], points1[0]) < uMath.pointDistance(points0[0], points1[1])) {
        pair1 = [points0[0], points1[0]];
        pair2 = [points0[1], points1[1]];
      }
      else {
        pair1 = [points0[0], points1[1]];
        pair2 = [points0[1], points1[0]];
      }
  
      var p0Vec = uMath.vectorFromSegment(uMath.segmentFromPoints(pair1[0], pair2[0]));
      var p1Vec = uMath.vectorFromSegment(uMath.segmentFromPoints(pair1[1], pair2[1]));
  
      var angle = uMath.vectorAngle(p0Vec, p1Vec);
      if (angle > 15) {
        return "Angle is too big between walls.";
      }
  
      var p1Center = uMath.segmentCenter(uMath.segmentFromPoints(pair1[0], pair1[1]));
      var p2Center = uMath.segmentCenter(uMath.segmentFromPoints(pair2[0], pair2[1]));
  
      var w11 = lineClosestPointToPoint(p1Center, points0[0], points0[1]);
      var w12 = lineClosestPointToPoint(p2Center, points0[0], points0[1]);
      var w21 = lineClosestPointToPoint(p1Center, points1[0], points1[1]);
      var w22 = lineClosestPointToPoint(p2Center, points1[0], points1[1]);
  
      points0 = [w11, w12];
      points1 = [w21, w22];
  
      var p0len = PlannerGlobals.LENGTHOF1PX * uMath.lineLength(uMath.segmentFromPoints(w11, w12));
      var p1len = PlannerGlobals.LENGTHOF1PX * uMath.lineLength(uMath.segmentFromPoints(w11, w12));
      var minLen = wallModHelper.minLengthCM[PlannerGlobals.entitySelectType];
  
      if (isPlannerImperial()) {
        p0len = cmToInch(p0len);
        p1len = cmToInch(p0len);
        minLen = wallModHelper.minLengthIN[PlannerGlobals.entitySelectType];
      }
  
      if (p0len < minLen ||
          p1len < minLen) {
        var lesser = Math.floor(p0len < p1len ? p0len : p1len);
        if (isPlannerMetric()) {
          return ts('p_wd_narrowerr', "The selection has to be wider than {0} centimeters. (You selected {1} cm.))").replace("{0}", minLen).replace("{1}", lesser);
        }
        else {
          return ts('p_wd_narrowerr_in', "The selection has to be wider than {0} inches. (You selected {1} in.))").replace("{0}", minLen).replace("{1}", lesser);
        }
      }
  
      return {
        room0:
            { points: points0, wallIds: wallIds0, isClockwise: isClockwise0, id: intersections[0].roomId },
        room1:
            { points: points1, wallIds: wallIds1, isClockwise: isClockwise1, id: intersections[1].roomId }
      };
    },
  sendWallMod(newWallModConn, callback, errorCallback) {
      newWallModConn.rooms.forEach(function (room) {
        room.type = newWallModConn.type;
        room.room_id = room.roomId;
        room.wall_ids = room.wallIds;
        room.x1 = room.points[0].x;
        room.y1 = room.points[0].y;
        room.x2 = room.points[1].x;
        room.y2 = room.points[1].y;
      });
      getAuthHeader(function (headers) {
        $.ajax({
          headers: headers,
          method: 'post',
          url: ROOT_URI + '/segment/create-segments',
          data: {
            segments: JSON.stringify(newWallModConn.rooms)
          },
          dataType: 'json',
          success: function (resp) {
            newWallModConn.id = resp.segment_group_id;
            if (newWallModConn.rooms.length == 1) {
              newWallModConn.rooms[0].id = resp.segment_part_id;
            }
            else if (newWallModConn.rooms.length == 2) {
              newWallModConn.rooms[0].id = resp.segment_part_1_id;
              newWallModConn.rooms[1].id = resp.segment_part_2_id;
            }
            newWallModConn.isAJAXWait = false;
            wallModHelperDOM.redrawWallMods();
            willCalcOuter();
            if (typeof callback === "function") {
              callback(newWallModConn);
            }
            if (PlannerGlobals.plannerEditableWallViewEnable === true) {
              toggleEditableWallViewMode(true);
            }
            // if (newWallModConn.type === "door") {
            //     newTour.triggerEvent({ done: 'draw_doors' });
            // }
            // else {
            //     newTour.triggerEvent({ done: 'draw_windows' });
            // }
          },
          error: function (resp) {
            PlannerGlobals.wallModConnections = PlannerGlobals.wallModConnections.filter(function (conn) { return conn !== newWallModConn; });
            wallModHelperDOM.redrawWallMods();
            genericXHRErrorHandler(resp);
            if (typeof errorCallback === "function") {
              errorCallback();
            }
          }
        });
      });
    },
  processAndSendWallMods: function (intersections) {
      if (wallModHelper.intersectionsOverlap(intersections)) {
        return toastErrorSingle(ts('p_wd_overlaperr', "Walls and doors <b>can't overlap</b> with one another!"));
      }
  
      if (intersections.length == 1) {
        // wall/window for only 1 room
        PlannerGlobals.entitySelectHadSuccess = true;
        var wallIds = wallModHelper.wallIdsFromIntersection(intersections[0]);
        var points = wallModHelper.pointsFromIntersection(intersections[0]);
  
        var length = Math.floor(PlannerGlobals.LENGTHOF1PX * uMath.lineLength(uMath.segmentFromPoints(points[0], points[1])));
        var minLen = wallModHelper.minLengthCM[PlannerGlobals.entitySelectType];
  
        if (isPlannerImperial()) {
          length = Math.floor(cmToInch(length));
          minLen = wallModHelper.minLengthIN[PlannerGlobals.entitySelectType];
        }
  
        if (length < minLen) {
          toastRemoveAll();
          if (isPlannerMetric()) {
            return toastInfo(ts('p_wd_narrowerr', "The selection has to be wider than {0} centimeters. (You selected {1} cm.))").replace("{0}", minLen).replace("{1}", length));
          }
          else {
            return toastInfo(ts('p_wd_narrowerr_in', "The selection has to be wider than {0} inches. (You selected {1} in.))").replace("{0}", minLen).replace("{1}", length));
          }
        }
        var newWallModConn = {
          rooms: [{
            points,
            wallIds,
            roomId: intersections[0].roomId,
            id: FAKE_WALLMOD_ID++
          }],
          type: PlannerGlobals.entitySelectType,
          id: FAKE_WALLCONN_ID++,
          isAJAXWait: true
        };
        const wssd = PlannerGlobals.wallSegmentation.getSaveData();
        PlannerGlobals.wallModConnections.push(newWallModConn);
        wallModHelperDOM.redrawWallMods();
        wallModHelperDOM.sendWallMod(newWallModConn, function () {
          var action = new CreateWallModAction(newWallModConn, wssd);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
          setMode.basic();
          PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
        });
      }
      else if (intersections.length == 2) {
        // wall/window for neighboring 2 rooms
        if (intersections[0].roomId != intersections[1].roomId) {
          var correction = wallModHelperDOM.neighborCorrection(intersections);
          if (typeof correction == "string") {
            toastRemoveAll();
            return toastInfo(correction);
          }
          // valid
          PlannerGlobals.entitySelectHadSuccess = true;
          var newWallModConn = {
            rooms: [
              {
                points: correction.room0.points,
                roomId: intersections[0].roomId,
                wallIds: correction.room0.wallIds,
                type: PlannerGlobals.entitySelectType,
                id: FAKE_WALLMOD_ID++
              },
              {
                points: correction.room1.points,
                roomId: intersections[1].roomId,
                wallIds: correction.room1.wallIds,
                type: PlannerGlobals.entitySelectType,
                id: FAKE_WALLMOD_ID++
              }
            ],
            type: PlannerGlobals.entitySelectType,
            id: FAKE_WALLCONN_ID++,
            isAJAXWait: true
          }
  
          if (wallModHelper.distanceOfWalls(newWallModConn) > CMToPx(wallModHelper.MAXCMDIST)) {
            return toastError(ts('p_wd_distanterr', 'The selected walls are too distant. (Max {0} cm.))').replace('{0}', wallModHelper.MAXCMDIST));
          }
          const wssd = PlannerGlobals.wallSegmentation.getSaveData();
          PlannerGlobals.wallModConnections.push(newWallModConn);
          wallModHelperDOM.redrawWallMods();
          wallModHelperDOM.sendWallMod(newWallModConn, function () {
            var action = new CreateWallModAction(newWallModConn, wssd);
            PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
            setMode.basic();
            PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
          });
        }
        else {
          // invalid
          toastRemoveAll();
          return toastInfo(ts('p_wd_badselect1', "You can't select two walls of the same room at the same time."));
        }
      }
      else if (intersections.length == 0) {
        toastRemoveAll();
        return toastInfo(ts('p_wd_badselect2', "Try <b>dragging</b> your mouse on <b>a wall</b>, or <b>two neighboring</b> walls."));
      }
      else {
        toastRemoveAll();
        return toastInfo(ts('p_wd_badselect3', "You can select <b>one</b> wall, or <b>two neighboring</b> walls only."));
      }
    }
};
